<template>
    <v-flex>
        <h2 v-if="currentTheme.title">{{ currentTheme.title }}</h2>
        <v-row class="center">
            <v-color-picker @input="colorChange" v-model="currentTheme.color" :elevation="elevation" />
        </v-row>
    </v-flex>
</template>

<script>
export default {
    props: {
        elevation: {
            type: Number,
            default: 0,
        },
        theme: {
            type: Object,
            default: undefined
        },
    },
    created() {
        this.currentTheme = this.theme;
    },
    data: () => ({
        currentTheme: null,
        fillTypes: [],
    }),
    methods: {
        colorChange(input) {
            console.log('change', input);
            this.$emit('color-change', { ...this.currentTheme, color: input.hex });
        }
    }
}
</script>
